import { useEffect, lazy, Suspense } from 'react';
import { useSocketStore } from './stores/useSocketStore';
import { useUserStore } from './stores/useUserStore';

const EarthScene = lazy(() => import('./scenes/EarthScene'));

function LoadingScreen(): JSX.Element {
  return (
    <div className="flex h-full items-center justify-center bg-space-900">
      <div className="text-center">
        <h1 className="text-4xl font-bold tracking-tight text-glow-blue animate-pulse">
          GlowEarth
        </h1>
        <p className="mt-2 text-sm text-gray-400">
          正在加载地球...
        </p>
      </div>
    </div>
  );
}

export default function App(): JSX.Element {
  const token = useUserStore((state) => state.token);
  const connect = useSocketStore((state) => state.connect);
  const disconnect = useSocketStore((state) => state.disconnect);
  const connected = useSocketStore((state) => state.connected);

  useEffect(() => {
    if (token) {
      connect(token);
    }
    return () => {
      disconnect();
    };
  }, [token, connect, disconnect]);

  // 监听全局未授权事件（API 拦截器触发）
  useEffect(() => {
    const handleUnauthorized = (): void => {
      useUserStore.getState().clearUser();
    };
    window.addEventListener('glowearth:unauthorized', handleUnauthorized);
    return () => {
      window.removeEventListener('glowearth:unauthorized', handleUnauthorized);
    };
  }, []);

  return (
    <div className="h-full w-full bg-space-900">
      <Suspense fallback={<LoadingScreen />}>
        <EarthScene />
      </Suspense>

      {/* 连接状态指示器 */}
      {token && !connected && (
        <div className="fixed top-2 right-2 rounded-full bg-yellow-500/80 px-3 py-1 text-xs text-black">
          连接中...
        </div>
      )}
    </div>
  );
}
